import { useDispatch } from "react-redux";
import {
  toggleBarcodeDialog,
  toggleCollapseItems,
  toggleDatePicker,
  toggleExpiryAlert,
  toggleOpenDeleteDialog,
  toggleOpenItemEditDialog,
  toggleOpenItemInfoDialog,
  toggleOpenRestockDialog,
  toggleOpenSellDialog,
  toggleOpenSettleCredit,
} from "../redux/GlobalStates";
import { toggleCart } from "../redux/cart";
import { useState } from "react";
import { toggleCreditDetails } from "../redux/Credit";

const useToggler = () => {
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);

  // toggle date picker
  const datePickerToggler = () => dispatch(toggleDatePicker());
  // toggle barcode dialog
  const barcodeDialogToggler = () => dispatch(toggleBarcodeDialog());
  //   toggle cart
  const cartToggler = () => dispatch(toggleCart());
  // toggle restock dialog
  const toggleRestockDialog = () => dispatch(toggleOpenRestockDialog());
  //   toggle item info dialog
  const toggleItemInfoDialog = () => dispatch(toggleOpenItemInfoDialog());
  //   toggle sell dialog
  const toggleSellDialog = () => dispatch(toggleOpenSellDialog());
  // toggle add form dialog
  const toggleAddFormDialog = () => setOpenAdd((prev) => !prev);
  // toggle expiry alert
  const ExpiryAlertToggler = () => dispatch(toggleExpiryAlert());
  // toggle credit details
  const showCreditDetailsToggler = () => dispatch(toggleCreditDetails());
  // toggle delete dialog
  const toggleDeleteDialog = () => dispatch(toggleOpenDeleteDialog());
  // toggle edit form
  const toggleEditForm = () => dispatch(toggleOpenItemEditDialog());

  const settleCreditToggler = () => dispatch(toggleOpenSettleCredit());
  //
  const collapseItemsSection = () => dispatch(toggleCollapseItems());
  return {
    datePickerToggler,
    barcodeDialogToggler,
    cartToggler,
    toggleRestockDialog,
    toggleItemInfoDialog,
    toggleSellDialog,
    toggleAddFormDialog,
    openAdd,
    ExpiryAlertToggler,
    showCreditDetailsToggler,
    toggleDeleteDialog,
    toggleEditForm,
    settleCreditToggler,
    collapseItemsSection,
  };
};

export default useToggler;
